export const TAX_VALUE = 0.22;
